import { render, staticRenderFns } from "./NewFila.vue?vue&type=template&id=0de0251e"
import script from "./NewFila.vue?vue&type=script&lang=js"
export * from "./NewFila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports